import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c334eba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自分配起", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "天有效", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最晚分配时间", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        ref: "name",
        label: "所属企业"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.enterpriseName), 1)
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, { label: "活动名称" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.activityName), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "折扣类型" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.discountTypeEnum[_ctx.detailInfo.discountType]), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "面额" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(`满 ${_ctx.detailInfo.fullAmount} 元减 ${_ctx.detailInfo.reduceAmount} 元`), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "使用渠道" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.channelText(_ctx.detailInfo)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "数量" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(`${_ctx.detailInfo.quantity} 张`), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "有效期" }, {
        default: _withCtx(() => [
          (_ctx.detailInfo.fixedTermFlag === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_a_form_item, { style: {"margin-top":"15px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, { align: "baseline" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 生效时间 "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.effectiveStartDate), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, { align: "baseline" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 失效时间 "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.effectiveEndDate), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 64))
            : (_ctx.detailInfo.fixedTermFlag === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_a_form_item, { style: {"margin-top":"15px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_space, { align: "baseline" }, {
                        default: _withCtx(() => [
                          _hoisted_1,
                          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.effectiveDays), 1),
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_space, { align: "baseline" }, {
                        default: _withCtx(() => [
                          _hoisted_3,
                          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.lastedEffectiveDate), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_a_divider, { dashed: "" }),
      _createVNode(_component_a_form_item, { label: "总面额" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.totalDenomination) + " 元", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "结算价格" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.settlementPrice) + " 元/张", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { label: "总结算价格" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.totalSettlementPrice) + " 元", 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["label-col", "wrapper-col"]))
}